<template>
  <TransitiongroupFilelist class="filelist" tag="ul">
    <slot />
  </TransitiongroupFilelist>


  <small v-if="validCount > maxFiles" class="validation-message">
    {{ maxFileNumberErrorMessage }}
  </small>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables/useI18n';
import TransitiongroupFilelist from '@/transitions/transitiongroup-filelist.vue';
import { computed } from 'vue';

const props = defineProps<{
  filecount: number;
  validfileCount: number;
  maxFiles: number;
}>();

const validCount = computed(() => props.validfileCount);
const { t } = useI18n();

// Validations:
const maxFileNumberErrorMessage = computed(() => {
  return props.maxFiles === 1 ?
    t('fileupload.maxFileNumberErrorMessageSingle') :
    t('fileupload.maxFileNumberErrorMessageMultiple', {count: props.maxFiles,});
})
</script>

<style scoped lang="scss">
.filelist {
  margin: 0;
  padding-left: 0px;
  list-style: none;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.validation-message {
  color: #e10000;
  display: block;
  text-align: center;
  padding: 4px 0;
  line-height: 1;
}
</style>
